export default __webpack_public_path__ + "static/media/cng copy.bc6e405d.png";